import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmKbRequestsReportsIssueRoute: InvariantJiraRoute = {
	name: 'csm-kb-requests-reports-time-scale-issue',
	path: '/jira/customer-service-management/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)/timescale/:timescaleId/:issueKey',
	exact: true,
};
